import { useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import { useNavigate } from 'react-router-dom';

export const useTaskSummary = () => {

    const { selectedEmployee } = useEmployeFilter();
    const [loader, setLoader] = useState(false);
    const [issueCount, setIssueCount] = useState({backlog: 0, in_progress: 0, done: 0})
    const [taskSummaryData, setTaskSummaryData] = useState([]);
    const navigate = useNavigate();

     const handleViewDetails = () => {
        navigate('/my-bucket'); 
    };

    useEffect(() => {
        selectedEmployee?.user_code && getTaskData()
    }, [selectedEmployee?.user_code])

    const getTaskData = async () => {
        try {
            setLoader(true);
            const today = new Date();
            const payload = {
                "month": today?.getMonth() + 1,
                "year": today?.getFullYear(),
                "requested_user_code": selectedEmployee?.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETMYBUCKETSUMMARY"), payload);
            if (res) {
                let data = res?.body?.data?.mybucket_summary;
                let issues = {backlog: 0, in_progress: 0, done: 0};
                data = data?.map((item) => {
                    item["size"] = item?.issue_percentage > 70 ? 80 : (item?.issue_percentage > 50 ? 70 : (item?.issue_percentage > 25 ? 50 : 35))
                    const category = item?.status_category?.toLowerCase();
                    if (category?.includes("done")) {
                        item["color"] = "green";
                        issues.done = item?.issues || 0;
                    } else if (category?.includes("progress")) {
                        item["color"] = "blue";
                        issues.in_progress = item?.issues || 0;
                    } else if (category?.includes("backlog")) {
                        item["color"] = "grey";
                        issues.backlog = item?.issues || 0;
                    }
                    return item;
                })
                setIssueCount(issues);
                setTaskSummaryData(data);
                setLoader(false);
            }

        } catch (error) {
            console.error("Error getting task data: ", error);
            setLoader(false);
            setTaskSummaryData([]);
        }
    }

    return useMemo(() => ({
        taskSummaryData,loader,issueCount,handleViewDetails
    }), [taskSummaryData,loader,issueCount,handleViewDetails])
}